import { useState } from 'react';

import { useGetChatById } from '~/hooks/apis/support/useChatById';

export function useSelectChatById() {
  const [selectedChatId, setSelectedChatId] = useState<string | null>(null);

  const { data: selectedChat = null, isLoading: loading } = useGetChatById({
    chatId: selectedChatId,
  });

  return {
    setSelectedChatId,
    selectedChat,
    loading,
  };
}
